import { publicApi } from '@/lib/axios/instances';
import { Announcement } from '@/types/announcement';

export const fetchAnnouncements = async (): Promise<Announcement[]> => {
  const { data } = await publicApi.get<Announcement[]>('/announcements');
  return data;
};